<template>
  <div class="animated fadeIn">
    <div class="block-screen" v-if="loading">
      <i class="fa fa-refresh fa-spin"></i>
    </div>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged"
    >
      <p>Voo atualizado com sucesso!</p>
      <b-progress
        variant="success"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="4px"
      >
      </b-progress>
    </b-alert>
    <b-modal
      title="Erro!"
      class="modal-danger"
      v-model="hasErrors"
      @ok="hasErrors = false"
      ok-variant="danger"
      ok-only
    >
      Não foi possível atualizar o voo.
    </b-modal>
    <b-modal id="modal-confirmation" title="Exclusão de voo" @ok="deleteFlight()">
      <p class="my-4">Tem certeza que deseja excluir este voo?</p>
    </b-modal>
    <b-row>
      <b-col lg="12">
        <b-card header="<i class='fa fa-plane'></i> Lista de Voos">
          <div class="row d-flex justify-content-between">
            <b-button
              size="sm"
              variant="primary"
              class="ml-3"
              @click="storeFlight()"
            >
              Cadastrar Voo<i class="fa fa-plane pl-2"></i>
            </b-button>
            <b-form-group horizontal class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Buscar..." />
                <b-input-group-button>
                  <b-btn variant="default"><i class="fa fa-search"></i></b-btn>
                </b-input-group-button>
              </b-input-group>
            </b-form-group>
          </div>
          <br /><br />
          <b-table
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            class="table-responsive-sm"
            :items="items"
            :fields="fields"
            :filter="filter"
            :current-page="currentPage"
            :per-page="perPage"
            @filtered="onFiltered"
          >
            <template slot="actions" slot-scope="data">
              <b-row class="form-group">
                <b-button
                  size="sm"
                  variant="primary"
                  v-b-modal.modal-confirmation
                  @click="deleteFlightId = data.item.id"
                  class="mr-1"
                  v-b-tooltip.hover
                  title="Excluir"
                  v-if="data.item.available_places === data.item.available"
                >
                  <i class="fa fa-trash"></i>
                </b-button>
                <b-button
                  size="sm"
                  variant="primary"
                  @click="editFlight(data.item.id)"
                  class="mr-1"
                  v-b-tooltip.hover
                  title="Editar"
                >
                  <i class="fa fa-edit"></i>
                </b-button>
                <b-button
                  size="sm"
                  variant="primary"
                  @click="showModal(data.item.id)"
                  class="mr-1"
                  v-b-tooltip.hover
                  title="Visualizar participantes"
                >
                  <i class="fa fa-folder-open"></i>
                </b-button>
              </b-row>
            </template>
          </b-table>
          <nav>
            <b-pagination
              :total-rows="getRowCount(items)"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Anterior"
              next-text="Próximo"
              hide-goto-end-buttons
            />
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      :id="'modallg' + flight.id"
      size="lg"
      ok-only
      v-for="flight in items"
      v-bind:key="flight.id"
      :title="
        'Vagas disponíveis: ' +
        flight.available +
        ' - Total de vagas: ' +
        flight.available_places
      "
    >
      <div class="row">
        <div class="col-md-12">
          <b-form inline>
            <label class="sr-only">Quantidade de vagas</label>
            <b-input-group left="" class="mb-2 mr-sm-2 mb-sm-0">
              <b-input
                placeholder="Quantidade de vagas"
                v-model="item.available_places"
              />
            </b-input-group>
            <b-button variant="primary" @click="update">Salvar</b-button>
          </b-form>
          <hr />
          <b-row>
            <b-col lg="12">
              <c-table
                striped
                :items="participants"
                :fields="participantFields"
                caption="<i class='fa fa-users'></i> Lista de Participantes que selecionaram este voo"
              >
              </c-table>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import cTable from "../../components/Table.vue";

export default {
  name: "tables",
  components: { cTable },
  props: {
    caption: {
      type: String,
      default: "Table",
    },
    hover: {
      type: Boolean,
      default: false,
    },
    striped: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      pending: false,
      showDismissibleAlert: false,
      hasErrors: false,
      item: {},
      items: [],
      fields: [
        { key: "group_number", label: "Nº do Grupo", sortable: true },
        { key: "city", label: "Cidade", sortable: true },
        { key: "company", label: "Companhia Aérea", sortable: true },
        // { key: "locator", label: "Localizador", sortable: true },
        { key: "available", label: "Disponíveis", sortable: true },
        { key: "available_places", label: "Total", sortable: true },
        { key: "actions", label: "Ações", sortable: true },
      ],
      participants: [],
      participantFields: [
        { key: "badge_name", label: "Nome de reconhecimento", sortable: true },
        { key: "cpf", label: "CPF", sortable: true },
        { key: "rg", label: "RG", sortable: true },
        { key: "validadeRg", label: "Validade do RG", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "actions", label: "Ações", sortable: false },
      ],
      deleteFlightId: null,
    };
  },
  mounted() {
    this.getFlights();
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    getFlights() {
      this.loading = true;
      this.$http
        .get(`flights`)
        .then((response) => {
          this.items = response.data.flights;
          this.items.forEach((item) => {
            item.departure_date = `${
              item.departure_flight
            } - ${item.departure_date.substr(0, 19)}`;
            item.return_date = `${
              item.return_flight
            } - ${item.return_date.substr(0, 19)}`;
            item.actions = { show: true, id: item.id, route: "Voo" };
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    update() {
      this.loading = true;
      const id = this.item[0].id;
      const data = { id: id, available_places: this.item.available_places };
      this.$http
        .put(`flights/${id}`, data)
        .then((response) => {
          this.loading = false;
          this.getFlights();
          this.showAlert();
          this.$root.$emit("bv::hide::modal", `modallg${id}`);
        })
        .catch(() => {
          this.$root.$emit("bv::hide::modal", `modallg${id}`);
          this.hasErrors = true;
          this.loading = false;
        });
    },
    getRowCount(items) {
      return items.length;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showModal(modal) {
      this.$root.$emit("bv::show::modal", `modallg${modal}`);
      this.item = this.items.filter((item) => {
        return item.id === modal;
      });
      this.participants = this.item[0].participants.map((item) => {
        item.actions = { show: true, id: item.user.id, route: "Participante" };
        return item;
      });
      this.item[0].guests.map((item) => {
        item.actions = { show: true, id: item.participant.user_id, route: "Participante" };
        console.log(item)
        item.badge_name = item.name + ' | Acompanhante de: ' + item.participant.badge_name;
        this.participants.push(item);
        return item;
      });
    },
    editFlight(id) {
      this.$router.push({
        name: "Editar voo",
        params: { id: id },
      });
    },
    deleteFlight() {
      this.$http
        .delete(`flights/${this.deleteFlightId}`)
        .then((response) => {
          this.loading = false;
          this.getFlights();
        })
        .catch(() => {
          this.hasErrors = true;
          this.loading = false;
        });
    },
    storeFlight() {
      this.$router.push({ name: "Manutenção de voo" });
    },
  },
};
</script>

<style>
.modal-lg {
  max-width: 90% !important;
}
.col-sm-9 {
  margin-left: -13px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/flights/List.vue